<template>
  <div class="indicator indicator--trigger--click cart-preview-container" :class="isOpenHeaderCart ? 'indicator--open' : ''" v-click-outside="closeCartPreview">
    <a href="javascript:void(0);" class="indicator__button" @click.prevent="isOpenHeaderCart = !isOpenHeaderCart">
      <span class="indicator__icon">
        <svg width="32" height="32">
          <circle cx="10.5" cy="27.5" r="2.5" />
          <circle cx="23.5" cy="27.5" r="2.5" />
          <path
            d="M26.4,21H11.2C10,21,9,20.2,8.8,19.1L5.4,4.8C5.3,4.3,4.9,4,4.4,4H1C0.4,4,0,3.6,0,3s0.4-1,1-1h3.4C5.8,2,7,3,7.3,4.3 	l3.4,14.3c0.1,0.2,0.3,0.4,0.5,0.4h15.2c0.2,0,0.4-0.1,0.5-0.4l3.1-10c0.1-0.2,0-0.4-0.1-0.4C29.8,8.1,29.7,8,29.5,8H14 	c-0.6,0-1-0.4-1-1s0.4-1,1-1h15.5c0.8,0,1.5,0.4,2,1c0.5,0.6,0.6,1.5,0.4,2.2l-3.1,10C28.5,20.3,27.5,21,26.4,21z"
          />
        </svg>
        <span class="indicator__counter">
            {{ cartquantity }}
        </span>
      </span>
      <span class="indicator__title">Shopping Cart </span>
      <span class="indicator__value notranslate">{{ toUSD(totals[0].ordertotal) }} </span>
    </a>
    <div class="indicator__content">
      <div class="dropcart">
        <ul class="dropcart__list">
          <li class="dropcart__item" v-for="(item, index) in cart" :key="item.linenumber">
            <div class="dropcart__item-image image image--type--product">
              <router-link :to="'/part/' + item.manufacturer + '/' + clearProductName(item) + '/' + item.mfgSeo + '/' + item.itemSeo" class="image__body">
                <img class="image__tag" :src="item.image" :alt="item.desc" />
              </router-link>
            </div>

            <div class="dropcart__item-info">
              <div class="dropcart__item-name">
                <router-link :to="'/part/' + item.manufacturer + '/' + clearProductName(item) + '/' + item.mfgSeo + '/' + item.itemSeo">
                  {{ item.desc }}
                </router-link>
              </div>
              <div class="dropcart__item-meta">
                <div class="dropcart__item-quantity">{{ item.quantity }}</div>
                <div class="dropcart__item-price notranslate">{{ toUSD(item.yourprice) }}</div>
                <div class="dropcart__item-price notranslate" v-if="item.corecharge > 0">{{ toUSD(item.corecharge) }}</div>
              </div>
            </div>
            <button type="button" class="dropcart__item-remove" @click="removeCartLine(index, 'item')">
              <svg width="10" height="10">
                <path
                  d="M8.8,8.8L8.8,8.8c-0.4,0.4-1,0.4-1.4,0L5,6.4L2.6,8.8c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L3.6,5L1.2,2.6 	c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L5,3.6l2.4-2.4c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L6.4,5l2.4,2.4 	C9.2,7.8,9.2,8.4,8.8,8.8z"
                />
              </svg>
            </button>

          </li>

          <!-- kit items -->
          <li class="dropcart__item" v-for="(item, index) in kits" :key="item.linenumber">
            <div class="dropcart__item-image image image--type--product">
              <router-link :to="'/kit-group/' + item.mfgcode + '/' + item.kitnumber" class="image__body">
                <img class="image__tag" :src="item.image" :alt="item.desc" />
              </router-link>
            </div>

            <div class="dropcart__item-info">
              <div class="dropcart__item-name">
                <router-link :to="'/kit-group/' + item.mfgcode + '/' + item.kitnumber">
                  {{ item.desc }}
                </router-link>
              </div>
              <div class="dropcart__item-meta">
                <div class="dropcart__item-quantity">{{ item.quantity }}</div>
                <!-- <div class="dropcart__item-price notranslate">{{ toUSD(item.yourprice) }}</div> -->
                <div class="dropcart__item-price notranslate">{{ toUSD(item.kit_gtotal) }}</div>
              </div>
            </div>
            <button type="button" class="dropcart__item-remove" @click="removeCartLine(index, 'kit')">
              <svg width="10" height="10">
                <path
                  d="M8.8,8.8L8.8,8.8c-0.4,0.4-1,0.4-1.4,0L5,6.4L2.6,8.8c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L3.6,5L1.2,2.6 	c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L5,3.6l2.4-2.4c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L6.4,5l2.4,2.4 	C9.2,7.8,9.2,8.4,8.8,8.8z"
                />
              </svg>
            </button>

          </li>
          <li class="dropcart__divider" role="presentation"></li>
          <!-- <li class="dropcart__divider" role="presentation"></li> -->
        </ul>
        <div class="dropcart__totals">
          <table>
            <tr>
              <th>Subtotal</th>
              <td class='notranslate'>{{ toUSD(totals[0].subtotal) }}</td>
            </tr>
            <tr v-if="totals[0].coretotal > 0">
              <th>Core</th>
              <td class='notranslate'>{{ toUSD(totals[0].coretotal) }}</td>
            </tr>
            <tr v-if="totals[0].shippingtotal > 0">
              <th>Shipping</th>
              <td class='notranslate'>{{ toUSD(totals[0].shippingtotal) }}</td>
            </tr>
            <tr v-if="this.customerIndicator === 'C' && totals[0].taxtotal > 0">
              <th>Estimated Tax</th>
              <td class='notranslate'>{{ toUSD(totals[0].taxtotal) }}</td>
            </tr>
            <tr v-if="totals[0].discounttotal > 0">
                <th>Promotional Discount:</th>
                <td class='notranslate'>- {{toUSD(totals[0].discounttotal)}}</td>
            </tr>
            <tr>
              <th>Total</th>
              <td class='notranslate'>{{ toUSD(totals[0].ordertotal) }}</td>
            </tr>
          </table>
        </div>
        <div class="dropcart__actions">
          <button class="btn btn-secondary mr-3"  @click="goToViewCart">View Cart</button>
          <button class="btn btn-checkout" @click="goToCheckout">Check Out</button>
        </div>
      </div>
    </div>
  </div>

  <base-dialog title="Confirm Delete" @close="cancelRemove" :open="selectedCartIndex != null">
    <template #default>
      <p>Are you sure you want to remove this item?</p>
    </template>
    <template #actions>
      <button type="button" class="btn btn-sm btn-secondary" @click="cancelRemove">
        Cancel
      </button>
      <button type="button" class="btn btn-sm btn-primary" @click="confirmRemove">
        Ok
      </button>

    </template>
  </base-dialog>

</template>

<script>
import { mapGetters } from 'vuex';
import Price from '../../../mixins/price.js';

export default {
    mixins: [Price],
    data() {
        return {
          selectedCartIndex: null,
          isOpenHeaderCart : false,
          toDelete: '',
        };
    },
    computed: {
        checkoutLink() {
          return this.customerIndicator === 'B' ? '/checkout-business' : '/checkout';
        },
        cartquantity() {
            let totalquantity = 0;
            for (let x in this.cart) {
                totalquantity += parseInt(this.cart[x].quantity);
            }

            for (let x in this.kits) {
                totalquantity += parseInt(this.kits[x].quantity);
            }
            return totalquantity;
        },
        ...mapGetters([
          'userIsAuthenticated',
          'customerIndicator'
        ]),
        ...mapGetters("cart", [
            "cart",
            "totals",
            'kits'
        ])
    },

    methods: {
      clearProductName(product){
          const clearProductName = encodeURIComponent(product.ID);

          return clearProductName;
      },

      removeCartLine(index, kit_or_item) {
        this.selectedCartIndex = index;
        this.toDelete = kit_or_item;
      },

      confirmRemove() {
        if(this.toDelete == 'item'){
          this.$store.dispatch('cart/removeCartLine', { "index": this.selectedCartIndex });
          this.items = this.cart;
          this.selectedCartIndex = null;
        }else{
          this.$store.dispatch('cart/removeKitLine', { "index": this.selectedCartIndex });
          // this.items = this.cart;
          this.selectedCartIndex = null;
        }
        
      },

      cancelRemove() {
        this.selectedCartIndex = null;
      },

      goToCheckout() {
        this.isOpenHeaderCart = false;

        if (this.customerIndicator === 'B'){
          this.$router.push("/checkout-business");
        }else{
          this.$router.push("/checkout");
        }
      },

      goToViewCart() {
        this.isOpenHeaderCart = false;
        this.$router.push("/cart");
      },

      closeCartPreview() {
        if (event.target.closest('.cart-preview-container') != undefined) {
          if (!event.target.closest('.cart-preview-container').className.match(/\bcart-preview-container\b/)) {
            // Check if this is a child element of the search button
            if (!event.target.className.match(/\bcart-preview-container\b/)) { 
              // Check if this is not the actual search button
              this.isOpenHeaderCart = false;
            }
          }
        } else {
          this.isOpenHeaderCart = false;
        }
      },
    },

    created() {
      // console.log(this.cart);
    }
}
</script>